import { joinCn } from '../util';
import { STATUS_BADGE_SIZE, STATUS_BADGE_VARIANT } from './constant';
import type { VStatusBadgeProps } from './type';

const twStyle = {
  vStatusBadge: ({ size, variant }: VStatusBadgeProps) => {
    return {
      container() {
        return joinCn(
          'box-border rounded-full font-bold text-white capitalize',
          {
            'min-w-[80px] px-2 py-1 text-body-s': size !== STATUS_BADGE_SIZE.SM,
            'h-5 min-w-[70px] px-2 text-body-ss': size === STATUS_BADGE_SIZE.SM,
          },
          {
            'bg-aiAnno-gradient': variant === STATUS_BADGE_VARIANT.AI_ANNO,
            'bg-completed-gradient': variant === STATUS_BADGE_VARIANT.COMPLETED,
            'bg-failed-gradient': variant === STATUS_BADGE_VARIANT.FAILED,
            'bg-inProgress-gradient':
              variant === STATUS_BADGE_VARIANT.IN_PROGRESS,
            'bg-inReview-gradient': variant === STATUS_BADGE_VARIANT.IN_REVIEW,
            'bg-notStarted-gradient':
              variant === STATUS_BADGE_VARIANT.NOT_STARTED ||
              variant === STATUS_BADGE_VARIANT.READY,
            'bg-rejected-gradient': variant === STATUS_BADGE_VARIANT.REJECTED,
            'bg-submitted-gradient': variant === STATUS_BADGE_VARIANT.SUBMITTED,
          },
        );
      },

      text() {
        return joinCn();
      },
    };
  },
} as const;

export default twStyle;
